import { BitkitAlert, BitkitAlertProps, BitkitLink } from '@bitrise/bitkit-v2';
import { useMemo } from 'react';

import useArchivedBuilds from '@/hooks/api/useArchivedBuilds';

type ArchivedBuildsSectionProps = { appSlug: string } & Omit<BitkitAlertProps, 'variant' | 'messageText'>;

const ArchivedBuildsSection = ({ appSlug, ...rest }: ArchivedBuildsSectionProps) => {
  const beforeTimestamp = useMemo(() => Math.floor(new Date().getTime() / 1000), []);
  const { archivedBuilds, isError } = useArchivedBuilds({
    appSlug,
    beforeTimestamp,
    afterTimestamp: 1,
    limit: 1,
  });

  if (!isError && (!archivedBuilds || archivedBuilds.length === 0)) {
    return null;
  }

  return (
    <BitkitAlert
      data-testid="archived-builds-list-notification"
      {...rest}
      variant="info"
      messageText={
        <>
          Bitrise archives builds older than 200 days. These are available via the REST API. You can use our{' '}
          <BitkitLink
            href="https://docs.bitrise.io/en/bitrise-ci/run-and-analyze-builds/build-data-and-troubleshooting/build-logs.html"
            textDecoration="underline"
            isExternal
          >
            retrieval guide
          </BitkitLink>{' '}
          to easily fetch archived build logs and artifacts.
        </>
      }
    />
  );
};

export default ArchivedBuildsSection;
